import React, {useContext, useEffect, useState} from 'react';
import Button from "@common/Button";
import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import {UserContext} from "@context/UserContext";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {CheckCircle, Pending} from "@mui/icons-material";
import QuestionFeedBackTable from "./QuestionFeedBackTable";

const TABS = {
    UNVIEWED: {val: 0, hash: 'unviewed'},
    VIEWED: {val: 1, hash: 'viewed'},
}

const QuestionFeedback = () => {
    const [feedbackViewed, setFeedbackViewed] = useState(false);
    const {user} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const [activeTabKey, setActiveTabKey] = useState(TABS.UNVIEWED.val);

    const handleTabChange = activeKey => {
        if(activeKey == TABS.UNVIEWED.val) {
            setFeedbackViewed(false);
        } else {
            setFeedbackViewed(true);
        }
        setActiveTabKey(activeKey);
    }

    return (
        <div>
            <Tabs onChange={handleTabChange} activeKey={activeTabKey} variant="standard" contentClassName="margin-t--l">
                <Tab tab={<>
                    <Pending className={'margin-r--m'}/>
                    <span className={'margin-r--m'}>Un-viewed Feedback</span>
                </>} key={TABS.UNVIEWED.val} hash={TABS.UNVIEWED.hash} />
                <Tab tab={ <>
                    <CheckCircle className={'margin-r--m'}/>
                    <span className={'margin-r--m'}>Viewed Feedback</span>
                </>} key={TABS.VIEWED.val} hash={TABS.VIEWED.hash} />
            </Tabs>
            <div>
                <QuestionFeedBackTable feedbackViewed={feedbackViewed}/>
            </div>
        </div>
    );
};

export default QuestionFeedback;
